import styled from '@emotion/styled'

import {graphql} from "gatsby";
import {BlogFooter} from '../../components/blog/Footer'
import {Slider} from '../../components/blog/Slider'
import {Body} from "../../components/Body";
import React, {useCallback, useEffect, useState} from "react"
import {Section} from '../../components/content'
import {CollectionBadge} from '../../components/helpCenter/CollectionBadge'
import {HelpHeader} from '../../components/helpCenter/Header'
import {HelpArticleCard} from '../../components/helpCenter/HelpArticleCard'
import {SliderTitle} from '../../components/helpCenter/SliderTitle'
import {SiteLink} from '../../components/SiteLink'
import {Colors, eerieBlack, violetBlue} from '../../styles/colors'
import {Spacing} from '../../styles/spacing'
import {Typography} from '../../styles/typography'
import {FuckedUpTypography} from '../../styles/typography.responsive'
import {isBrowser, isDesktop} from '../../styles/utils'
import {helpCenterName} from '../../utils/blog/const'
import {HeroContainer} from '../helpCenterHomepage/template'
import {HelpContent} from './styled'
import ThumbUpIcon from '../../icons/thumb-up.svg'
import ThumbDownIcon from '../../icons/thumb-down.svg'

const ReactionContainer = styled.div`
  height: 166px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0px 48px 0px;
  flex-direction: column;

  button {
    background-color: transparent;
    border: none; /* Remove borders */
    padding: 0; /* Some padding */
    cursor: pointer; /* Mouse pointer on hover */
    transition: 0.3s all;
  }

  button:active svg {
    transform: scale(1.10);
    color: ${eerieBlack["400"]};
  }

  button:disabled svg {
    opacity: 0.8;
    cursor: not-allowed;
    transform: scale(1);
    color: ${eerieBlack["600"]};
  }
`
/**
 * /website/help-center/1234/view
 * /website/help-center/1234/like
 * /website/help-center/1234/dislike
 */
const HelpCenterArticle = ({data, pageContext}) => {
  const {
    allCollections: {edges: [{node: collection}]},
    allArticles: {edges: [{node: article}]},
    relatedArticles: {edges: relatedArticles},
    site: {siteMetadata: {apiUrl}}
  } = data
  const { helpRedirects } = pageContext
  const [alreadyVoted, setVoted] = useState(isBrowser && sessionStorage.getItem(article.slug) === 'voted')

  useEffect(() => {
    // on page mount send pageView event
    isBrowser && fetch(`${apiUrl}/website/help-center/${article.id__normalized}/view`)
  }, [])

  const onVote = (action) => {
    if (!alreadyVoted) {
      fetch(`${apiUrl}/website/help-center/${article.id__normalized}/action`)
      sessionStorage.setItem(article.slug, 'voted')
      setVoted(true)
    }
  }
  return (
    <Body dmSans safe={false} FooterComponent={BlogFooter} HeaderComponent={HelpHeader}>
      {/*Hero */}
      <Section backgroundColor={collection.color} noSpacing internalStyle={isDesktop() ? {
        maxWidth: '740px',
        height: '358px',
        paddingBottom: '80px'
      } : {maxWidth: '740px', height: '358px', paddingBottom: '72px'}}>
        <HeroContainer>
          <SiteLink to={`/${helpCenterName}/${collection.slug}`} css={Spacing.Margin.bottom_16} name={collection.name}>
            <CollectionBadge size="large" backgroundColor={eerieBlack[0]} color={collection.color}
                             css={[Spacing.Margin.right_auto]} name={collection.name}/>
          </SiteLink>
          <h2
            css={[FuckedUpTypography.heading.h2_700, Colors.Color.eerieBlack0, Spacing.Margin.bottom_16]}>{article.title}</h2>
          <span css={[Typography.heading.h5_400, Colors.Color.eerieBlack0]}>{article.description}</span>
        </HeroContainer>
      </Section>
      <Section internalStyle={isDesktop() ? undefined : {paddingTop: '20px'}}>
        <HelpContent>
          {/* The main post content */}
          <div
            className="content-body load-external-scripts"
            dangerouslySetInnerHTML={{__html: reAdaptHtml(article.body, helpRedirects)}}
          />
        </HelpContent>
      </Section>
      <Section noSpacing backgroundColor={eerieBlack["100"]} full>
        <ReactionContainer>
          <span css={[Typography.label.label1_400, Colors.Color.eerieBlack600, Spacing.Margin.bottom_16]}>Hai trovato la risposta che cercavi?</span>
          <div css={[Spacing.Flex.row]}>
            <button disabled={alreadyVoted} onClick={() => onVote('like')}>
              <ThumbUpIcon css={[Colors.Color.eerieBlack600, Spacing.Margin.right_32,]}/>
            </button>
            <button disabled={alreadyVoted} onClick={() => onVote('dislike')}>
              <ThumbDownIcon css={[Colors.Color.eerieBlack600]}/>
            </button>
          </div>
        </ReactionContainer>
      </Section>
      <Section>
        <SliderTitle title="Articoli correlati"/>
        <Slider>
          {relatedArticles.map(({node}) => (
            <HelpArticleCard key={node.id} article={node} collection={collection}/>
          ))}
        </Slider>
      </Section>
    </Body>
  )
}
export default HelpCenterArticle
const sectionsRegex = RegExp('<h[1-6] id="([^"]+)">([^<]+)<\\/h[1-6]>', 'gi')
const targetBlankRegExp = RegExp(/(https?:\/\/help.tate.it\/it\/articles\/.[^"\']+.[^target="_balnk"]+)target="_blank/, 'g')
const helpLinkRegex = RegExp(/href=["']https?:\/\/help.tate.it\/it\/articles\/(\d+).[^"\']+/, 'g')
const reAdaptHtml = (html = '', helpRedirects) => {
  let output = html
  // Setup



  //replace intercom link change href url and remove target if it exists

  output = output.replace(targetBlankRegExp, '$1')

  output = output.replace(helpLinkRegex, (_, intercomID) => {
    // se esiste articolo nella mappa redirects lo cambio
    if(helpRedirects[intercomID]) return `internal="true" href="/${helpRedirects[intercomID]}`
    console.warn('Articolo non presente nalla mappa redirects from intercom id', intercomID)
    return _
  })

  // Search for sections in page
  let sections = []
  let section
  while ((section = sectionsRegex.exec(html)) !== null) {
    sections.push(section)
  }

  let menu = ''
  // If required, generate the mini-menu
  if (sections.length > 1) {
    menu = `
      <div class="summary">
        <h4>Sommario</h4>
        <ul>
          ${sections.map(section => (`<li><a href="#${section[1]}">${section[2]}</a></li>`)).join('')}
        </ul>
        <div class="summary-divider"><span>*</span><span>*</span><span>*</span></div>
      </div>
    `
  }
  output = `${menu} ${output}`

  return output
}


export const helpCenterArticleQuery = graphql`
  query($articleId: String, $collectionId: Int) {
    allArticles(filter: {id: {eq: $articleId}}) {
      edges {
        node {
          id__normalized
          title
          description
          body
          slug
        }
      }
    }
    relatedArticles: allArticles(filter: {CollectionId: {eq: $collectionId}, id: {ne: $articleId}}, sort: {fields:[likeCount], order:[DESC]}, limit: 3) {
      edges {
        node {
          id__normalized
          title
          description
          body
          slug
        }
      }
    }
    allCollections(filter: {id__normalized: {eq: $collectionId}}) {
      edges {
        node {
          name
          color
          icon
          slug
        }
      }
    }
    site {
      siteMetadata {
        apiUrl
      }
    }
  }
 `
